
export const Inputs = [
    [
        {
            type: "email",
            name: "email",
            title: { ar: "", en: "" },
            label: { ar: "", en: "" },
            placeholder: { ar: "البريد الالكتروني", en: "Email" },
            size: { lg: "12", md: "6" }
        },
      
    ]

];

